export default {
  ko: {
    login: "로그인",
    signup: "회원가입",
    search: "검색",
    group: "그룹 검색",
    detail: "상세검색",
    more: "상세보기",
    country: "국가",
    website: "웹사이트",
    phone: "전화번호",
    reset: "초기화",
    companyNm: "기업명",
    suppliers: "공급자",
    keyword: "키워드",
    establish: "설립년도",
    itemNm: "상품명",
    companyNmRussian: "기업명(러시아어)",
    attention: "관심기업",
    matching: "매칭관리",
    logout: "로그아웃",
    editProfile: "정보수정",
    id: "아이디",
    email: "이메일",
    password: "비밀번호",
    passwordConfirm: "비밀번호 확인",
    trySignup: "가입하기",
    alreadyUser: "이미 계정이 있습니까?",
    policy: "정책약관",
    usePolicy: "이용약관, 개인정보 수집 및 이용에 동의합니다.",
    usePolicy_title1: "1. 개인정보의 처리 목적",
    usePolicy_content1:
      "<쿠노소프트>('http://www.kounosoft.com/'이하 '(주)쿠노소프트')은(는) 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다. 가. 홈페이지 회원가입 및 관리 - 회원제 서비스 제공에 따른 본인 식별·인증 등을 목적으로 개인정보를 처리합니다.",
    usePolicy_title2: "2. 개인정보 파일 현황",
    usePolicy_content2:
      "1. 개인정보 파일명 : 개인정보 - 개인정보 항목 : 이메일, 휴대전화번호, 비밀번호, 로그인ID, 성별, 이름, 직책, 부서, 회사명 - 수집방법 : 홈페이지, 제휴사로부터 제공 받음 - 보유근거 : 원활한 서비스를 제공하기 위해 - 보유기간 : 준영구 - 관련법령 : 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년",
    usePolicy_title3: "3. 개인정보의 처리 및 보유 기간",
    usePolicy_content3_1:
      "①<쿠노소프트>('(주)쿠노소프트')은(는) 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집시에 동의 받은 개인정보 보유,이용기간 내에서 개인정보를 처리 · 보유합니다.",
    usePolicy_content3_2:
      "② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다. 1.[ 홈페이지 회원가입 및 관리] - [홈페이지 회원가입 및 관리] 와 관련한 개인정보는 수집.이용에 관한 동의일로부터 [준영구] 까지 위 이용목적을 위하여 보유 · 이용됩니다. - 보유근거 : 사용자가 소속된 회사에 다니는 동안에는 보관 - 관련법령 : 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년 - 예외사유 :",
    usePolicy_title4: "4. 개인정보의 제3자 제공에 관한 사항",
    usePolicy_content4_1:
      "① <쿠노소프트> ('http://www.kounosoft.com/'이하 '(주)쿠노소프트')은(는) 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.",
    usePolicy_content4_2:
      "② <쿠노소프트>('http://www.kounosoft.com/')은(는) 다음과 같이 개인정보를 제3자에게 제공하고 있습니다. 1.(주)쿠노소프트 개인정보를 제공받는 자 : (주)쿠노소프트 제공받는 자의 개인정보 이용목적 : 이메일, 휴대전화번호, 비밀번호, 로그인ID, 성별, 이름, 직책, 부서, 회사명 제공받는 자의 보유.이용기간: 준영구",
    usePolicy_title5: "5. 개인정보처리 위탁",
    usePolicy_content5_1:
      "① <쿠노소프트> ('(주)쿠노소프트')은(는) 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.",
    usePolicy_content5_2:
      "② <쿠노소프트>('http://www.kounosoft.com/'이하 '(주)쿠노소프트')은(는) 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.",
    usePolicy_content5_3:
      "③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.",
    saveID: "아이디 저장하기",
    findID: "아이디 찾기",
    findPassword: "비밀번호 찾기",
    noneUser: "계정이 없습니까?",
    goHome: "홈으로",
    goBack: "돌아가기",
    findEmail: "가입시 등록했던 이메일을 입력해주세요.",
    initPassword: "비밀번호 초기화 링크를 받을 이메일 주소를 입력해주세요.",
    send: "전송하기",
    confirm: "확인",
    welcome: "환영합니다!",
    mailTranseSuc: "메일 전송 성공",
    passmailSuccess: "등록된 이메일로 비밀번호 재설정 메일을 전송하였습니다.",
    checkMail: "메일함을 확인해주세요.",
    plsEntID: "아이디를 입력해주세요.",
    existID: "아이디가 존재하지 않습니다.",
    lookupResults: "조회 결과",
    signupResults: "회원 가입 결과",
    notVerifiedEmail: "이메일 인증이 되지 않았습니다!",
    notCompletedyetEmail: "아직 이메일 인증이 완료되지 않았습니다.",
    linkCompleted: "받으신 이메일을 열어 링크를 클릭하면 가입이 완료됩니다.",
    notRecevied: "이메일을 받지 못했습니까?",
    registration: "사업자 등록번호",
    registrationDate: "설립일자(년도-월-일)",
    address: "주소",
    principal: "대표자 명",
    business: "산업 명",
    worker: "근무자 수",
    revenue: "수익",
    attentionReg: "관심기업등록",
    requestedMat: "요청한 매칭",
    incomMat: "들어온 매칭",
    matchingHistory: "매칭 이력",
    matchingReqTitle: "매칭 요청서",
    matchingReq: "매칭요청",
    matchingComp: "매칭 요청 완료",
    matchingAdded: "해당 기업에 매칭 요청을 완료하였습니다.",
    matchingCompDup: "@",
    matchingAddedDup:
      "중복된 매칭입니다. 이미 매칭을 요청하셨거나, 상대방으로부터 매칭 요청을 받으셨습니다.",
    matNotAllowed:
      "매칭대상회사 계정이 없습니다.\n\n 관리자에게 문의하시기 바랍니다.",
    matProccess:
      "요청을 처리하고 있습니다. 잠시만 기다려주세요!\n 요청이 완료되면 아래 버튼이 활성화됩니다.",
    matchingError:
      "오류가 발생하였습니다.\n\n 관리자에게 문의하시기 바랍니다.",
    attentionComp: "관심 등록 완료",
    attentionAdded: "해당 기업을 관심 기업으로 추가하였습니다.",
    attentionCompDup: "@",
    attentionAddedDup: "이미 등록되어 있는 기업입니다.",
    manageProfile: "프로필 관리",
    registedEmail: "등록된 이메일",
    changePassword: "비밀번호 변경하기",
    toEdit: "수정하기",
    toDelete: "삭제하기",
    toCreate: "생성하기",
    resetPassword: "비밀번호 재설정",
    newPassword: "새 비밀번호",
    trychangePassword: "비밀번호 변경",
    changeCompPassword: "비밀번호 변경 완료",
    changedPassword: "비밀번호가 변경되었습니다.",
    plzLogin: "로그인해주세요.",
    verifiedEmail: "이메일 인증",
    sendEmail: "(으)로 인증 메일이 전송되었습니다.",
    openEmail: "받으신 이메일을 열어 링크를 클릭하면 가입이 완료됩니다.",
    Russia: "러시아",
    Korea: "한국",
    Ozbekiston: "우즈베키스탄",
    Kyrgyzstan: "키르기스스탄",
    Kazakhstan: "카자흐스탄",
    Ukraine: "우크라이나",
    Belarus: "벨라루스",
    noResult: "검색 결과가 없습니다",
    deactivate: "비활성화",
    deactSuccess: "선택한 회원이 비활성화 되었습니다.",
    deactFail: "비활성화가 불가능한 계정입니다",
    actSuccess: "선택한 회원이 활성화 되었습니다.",
    activate: "활성화",
    compCreateSuccess: "기업이 생성됐습니다.",
    compDeleteSuccess: "해당 기업이 삭제되었습니다",
    compDeleteFail:
      "기업 계정을 사용하고 있는 사용자가 있어 삭제할 수 없습니다",
    notAllowed: "허용되지 않은 접근",
    notAllowedUser: "고객님의 계정은 관리자에 의해 비활성화 되었습니다.",
    success: "성공",
    fail: "실패",
    survayTitle: "만족도 설문 조사 페이지",
    survayResponseCompanyNm: "응답자 기업명",
    survayMatchingCompanyNm: "매칭 상대 기업명",
    survayRespondentNm: "응답자 성명",
    survayRespondentContract: "응답자 연락처",
    survayRespondentEmail: "응답자 이메일",
    survayContent: "설문 내용",
    survayVeryGood_1: "매우",
    survayVeryGood_2: "만족",
    survayGood_1: " ",
    survayGood_2: "만족",
    survayCommon: "보통",
    survayDissatisfaction_1: " ",
    survayDissatisfaction_2: "불만족",
    survayVeryDissatisfaction_1: "매우",
    survayVeryDissatisfaction_2: "불만족",
    survayVeryMuch_1: "매우",
    survayVeryMuch_2: "있음",
    survayMuch: "있음",
    survayNormal: "보통",
    survayLittle: "없음",
    survayVeryLittle_1: "매우",
    survayVeryLittle_2: "없음",
    survayQuection1_1: "1. 상대국 기업 정보를 검색하는",
    survayQuection1_2: "기능에 만족하십니까?",
    survayQuection2_1: "2. 상대국 기업과 매칭이",
    survayQuection2_2: "기대한 만큼 잘 되었습니까?",
    survayQuection3_1: "3. 상대국 기업과의 매칭 후",
    survayQuection3_2: "커뮤니케이션이 원활히 진행되었습니까?",
    survayQuection4_1: "4. 당신은 이 웹을 주변 기업이나 동료에게 ",
    survayQuection4_2: "추천할 의향이 있으십니까?",
    survayQuection5: "5. 당신은 해당 어플리케이션을 다시 사용할 의향이 있으십니까?",
    survayQuection6: "6. 어플리케이션 개선요청 또는 건의사항이 있으면 기재해주세요.",
    survayConfirm: "제출",
    agriculture: "농업",
    mining: "광업",
    manufacturing: "제조업",
    electricity: "전기공사",
    water_supply: "수도공사",
    construction: "건설업",
    wholesale: "도매업",
    transportation: "운송업",
    accomodation: "숙박업",
    information: "정보업체",
    financial: "금융 서비스업",
    real_estate: "부동산",
    keyword: "키워드",
    company_content: "회사 소개",
    sidebar01: "농업",
    sidebar011: "작물 재배업",
    sidebar0111: "곡물 및 기타 식량작물 재배업",
    sidebar0112: "채소, 화훼작물 및 종묘 재배업",
    sidebar01121: "채소작물 재배업",
    sidebar01122: "화훼작물 재배업",
    sidebar01123: "종자 및 묘목 생산업",
    sidebar0113: "과실, 음료용 및 향신용 작물 재배업",
    sidebar01131: "과실작물 재배업",
    sidebar01132: "화훼작물 재배업",
    sidebar0114: "물 및 기타 식량작물 재배업",
    industyCode: "산업 번호",
  },
  en: {
    login: "Log in",
    signup: "Sign up",
    search: "Search",
    group: "Group Search",
    detail: "Detail Search",
    country: "Country",
    more: "Detail",
    website: "Website",
    phone: "Phone Number",
    reset: "Reset",
    companyNm: "Company Name",
    suppliers: "Suppliers",
    keyword: "Keyword",
    establish: "Establish",
    companyNmRussian: "Company Name in Russian",
    attention: "Attention",
    requestedMat: "Requested Matching",
    incomMat: "Incoming Matching",
    matching: "Matching",
    logout: "Log out",
    editProfile: "Edit Profile",
    id: "ID",
    email: "E-Mail",
    password: "Password",
    passwordConfirm: "Password Confirm",
    trySignup: "sign up",
    alreadyUser: "Already have an account?",
    policy: "Policy Terms",
    usePolicy:
      "I agree to the Terms of Use, collection and use of personal information.",
    usePolicy_title1: "1. Purpose of processing personal information",
    usePolicy_content1:
      "<Kunosoft> ('http://www.kounosoft.com/' hereafter referred to as 'Kunosoft') processes personal information for the following purposes. The processed personal information will not be used for any purpose other than the following, and prior consent will be sought when the purpose of use is changed. go. Website membership registration and management - Personal information is processed for the purpose of identification and authentication according to the provision of membership service.",
    usePolicy_title2: "2. Personal information file status",
    usePolicy_content2:
      "1. Personal information file name: Personal information - Personal information items: E-mail, mobile phone number, password, login ID, gender, name, position, department, company name - Collection method: Homepage, provided by affiliates - Basis of retention: Smooth service - Retention period: quasi-permanent - Relevant laws: Records on collection/processing and use of credit information: 3 years",
    usePolicy_title3:
      "3. Processing and retention period of personal information",
    usePolicy_content3_1:
      "① <Kunosoft> ('Kunosoft Co., Ltd.') retains personal information within the period of retention and use of personal information in accordance with laws and regulations or the period of use and retention of personal information agreed upon when collecting personal information from the information subject. Handled and retained.",
    usePolicy_content3_2:
      "② Each personal information processing and retention period is as follows. 1.[Website membership registration and management] - Personal information related to [Website membership registration and management] is retained and used for the above purposes from the date of consent for collection and use to [quasi-permanent]. - Basis for retention: Retention while attending the company to which the user belongs - Relevant laws: Records on collection/processing and use of credit information: 3 years",
    usePolicy_title4:
      "4. Matters concerning the provision of personal information to third parties",
    usePolicy_content4_1:
      "① <Kunosoft> ('http://www.kounosoft.com/' hereafter referred to as 'Kunosoft Co., Ltd.') has the consent of the information subject and Articles 17 and 18 of the Personal Information Protection Act, such as special provisions of the law We provide personal information to third parties only in cases falling under the provisions of this Article.",
    usePolicy_content4_2:
      "② <Koonosoft> ('http://www.kounosoft.com/') provides personal information to third parties as follows. 1. Persons who receive personal information from Kunosoft Corporation: Purpose of use of personal information provided by Kunosoft Corporation: Email, mobile phone number, password, login ID, gender, name, position, department, company name Retention and use period: semi-permanent",
    usePolicy_title5: "5. Consignment of personal information processing",
    usePolicy_content5_1:
      "① <Kunosoft> ('Kunosoft Co., Ltd.') entrusts the following personal information processing tasks for smooth personal information processing.",
    usePolicy_content5_2:
      "② <Kunosoft> ('http://www.kounosoft.com/' hereafter referred to as 'Kunosoft Co., Ltd.') processes personal information other than for the purpose of performing entrusted tasks in accordance with Article 25 of the Personal Information Protection Act when concluding a consignment contract Responsibilities such as prohibition, technical and administrative protection measures, restrictions on re-entrustment, management and supervision of the trustee, and compensation for damages are specified in the contract and other documents, and the trustee handles personal information safely.",
    usePolicy_content5_3:
      "③ If the contents of the consignment work or the trustee is changed, we will disclose it through this personal information processing policy without delay.",
    saveID: "Save ID",
    findID: "Find ID",
    findPassword: "Find Password",
    noneUser: "Don't have an account?",
    goHome: "Go Home",
    goBack: "Back",
    findEmail: "Please enter the email you registered with when registering.",
    initPassword:
      "Please enter your email address to receive a password reset link.",
    send: "To Send",
    confirm: "Confirm",
    welcome: "Welcome!",
    mailTranseSuc: "Mail sent success",
    passmailSuccess:
      "A password reset email has been sent to the registered email address.",
    checkMail: "Please check your mailbox.",
    plsEntID: "Please enter your ID.",
    existID: "ID does not exist.",
    lookupResults: "LookUp results",
    signupResults: "SignUp results",
    notVerifiedEmail: "Email is not verified!",
    notCompletedyetEmail: "Email verification has not been completed yet.",
    linkCompleted:
      "Open the email you received and click on the link to complete your registration.",
    notRecevied: "Didn't receive an email?",
    registration: "Registration ID",
    registrationDate: "Date of Registration (yyyy-mm-dd)",
    address: "Legal Address",
    principal: "Principal Name",
    business: "Line Of Business",
    worker: "Number Of Workers",
    revenue: "Revenue",
    attentionReg: "Registered as a company of interest",
    matchingReqTitle: "Contract Request",
    matchingReq: "Matching Request",
    attentionComp: "Interest registration completed",
    attentionAdded: "We have added the company as a company of interest.",
    manageProfile: "Profile Management",
    registedEmail: "Registered Email",
    changePassword: "Change your password",
    toEdit: "To Edit",
    resetPassword: "Reset password",
    newPassword: "New password",
    trychangePassword: "Change Password",
    changeCompPassword: "Password change complete",
    changedPassword: "Your password has been changed.",
    plzLogin: "Please log in.",
    verifiedEmail: "Email Authentication",
    sendEmail: "Send verification mail",
    openEmail:
      "Open the email you received and click on the link to complete your registration.",
    Russia: "Russia",
    Korea: "Korea",
    Ozbekiston: "Oʻzbekiston",
    Kyrgyzstan: "Kyrgyzstan",
    Kazakhstan: "Kazakhstan",
    Ukraine: "Ukraine",
    Belarus: "Belarus",
    noResult: "No Results Found",
    survayTitle: "Satisfaction Survey Page",
    survayResponseCompanyNm: "Responding Company Name",
    survayMatchingCompanyNm: "Matching Partner Company Name",
    survayRespondentNm: "Respondent Name",
    survayRespondentContract: "Respondent Contact",
    survayRespondentEmail: "Respondent E-Mail",
    survayContent: "Survey Content",
    survayVeryGood_1: "Very",
    survayVeryGood_2: "Good",
    survayGood_1: " ",
    survayGood_2: "Good",
    survayCommon: "Commonly",
    survayDissatisfaction_1: " ",
    survayDissatisfaction_2: "Dissatisfaction",
    survayVeryDissatisfaction_1: "Very",
    survayVeryDissatisfaction_2: "Dissatisfaction",
    survayVeryMuch_1: "Very",
    survayVeryMuch_2: "Much",
    survayMuch: "Much",
    survayNormal: "So so",
    survayLittle: "Little",
    survayVeryLittle_1: "Very",
    survayVeryLittle_2: "Little",
    survayQuection1_1: "1. Are you satisfied with the function of searching",
    survayQuection1_2: "for company information in other countries?",
    survayQuection2_1: "2. Did it match the other country's",
    survayQuection2_2: "companies as well as expected?",
    survayQuection3_1: "3. Did communication proceed smoothly",
    survayQuection3_2: "after matching with the other country's company?",
    survayQuection4_1: "4. Are you willing to recommend this web",
    survayQuection4_2: "to your surrounding companies or colleagues?",
    survayQuection5: "5. Are you willing to use the application again?",
    survayQuection6: "6. If you have any application improvement requests or suggestions, please write them down.",
    survayConfirm: "Confirm",
    agriculture: "Agriculture",
    mining: "Mining",
    manufacturing: "Manufacturing",
    electricity: "Electricity",
    water_supply: "Water Supply",
    construction: "Construction",
    wholesale: "Wholesale",
    transportation: "Transportation",
    accomodation: "Accomodation",
    information: "Information",
    financial: "Financial",
    real_estate: "Real estate",
    keyword: "Keyword",
    company_content: "Company Content",
    industyCode: "Industry Code",
  },
  ru: {
    login: "Авторизоваться",
    signup: "Подписаться",
    search: "Поиск",
    attention: "Внимание",
    matching: "Соответствие",
    logout: "Выйти",
    editProfile: "Редактировать профиль",
    Russia: "Россия",
    Korea: "Корея",
    companyNm: "Название компании",
    suppliers: "Поставщики",
    keyword: "Ключевое слово",
    Ozbekiston: "Узбекистан",
    Kyrgyzstan: "Кыргызстан",
    Kazakhstan: "Казахстан",
    Ukraine: "Украина",
    Belarus: "Беларусь",
    establish: "Учреждать",
    survayTitle: "Анкета для опроса удовлетворенности",
    survayResponseCompanyNm: "Название компании респондента",
    survayMatchingCompanyNm: "Название компании в стране-партнере",
    survayRespondentNm: "ФИО респондента",
    survayRespondentContract: "Контактные данные респондента",
    survayRespondentEmail: "Эл. Адрес респондента",
    survayContent: "Содержание опроса",
    survayVeryGood_1: "очень",
    survayVeryGood_2: "удолетворен",
    survayGood_1: "удолет",
    survayGood_2: "ворен",
    survayCommon: "обычно",
    survayDissatisfaction_1: "неудолет",
    survayDissatisfaction_2: "ворен",
    survayVeryDissatisfaction_1: "очень",
    survayVeryDissatisfaction_2: "неудовлетворен",
    survayVeryMuch_1: "всем",
    survayVeryMuch_2: "рекомендую",
    survayMuch: "рекомендую",
    survayNormal: "Так себе",
    survayLittle: "нет",
    survayVeryLittle_1: "вообще",
    survayVeryLittle_2: "нет",
    survayQuection1_1: `1. Удовлетворены ли вы возможностью поиска`,
    survayQuection1_2: `информации о компании в других странах?`,
    survayQuection2_1: "2. Сработало ли согласование со",
    survayQuection2_2: "страной-партнером, как ожидалось?",
    survayQuection3_1: "3. После согласования  со страной-партнером,",
    survayQuection3_2: "коммуникация прошла гладко?",
    survayQuection4_1: "4. Вы готовы порекомендовать это",
    survayQuection4_2: "приложение предприятиям и коллегам?",
    survayQuection5: "5. Готовы ли вы снова использовать приложение?",
    survayQuection6: "6. Если у вас есть запрос на улучшение приложения или предложение, прошу написать.",
    survayConfirm: "Разместить",
    agriculture: "сельское хозяйство",
    mining: "Добыча",
    manufacturing: "Производство",
    electricity: "Электричество",
    water_supply: "Водоснабжение",
    construction: "Строительство",
    wholesale: "Оптовая",
    transportation: "Транспорт",
    accomodation: "Размещение",
    information: "Информация",
    financial: "финансовый",
    real_estate: "Недвижимость",
    keyword: "Ключевое слово",
    company_content: "О нас",
    lookupResults: "Результаты поиска",
    signupResults: "Результаты регистрации",
    industyCode: "Отраслевой кодекс",
  },
};
